// Cursul 1 e gratuit; 2, 3, 4 sunt Premium (vezi mockCourses din CoursesInPlace.jsx).
export const FREE_COURSE_IDS = [1];

export const clearCourseStorage = () => {
  try {
    localStorage.removeItem('selectedCourseId');
    localStorage.removeItem('enrolledCourses');
  } catch (_) {
    // storage indisponibil
  }
};

// localStorage nu e de incredere (dispozitive comune): fara Premium ramane doar cursul gratuit.
// Intoarce true daca a modificat ceva.
export const enforceFreeCoursesOnly = () => {
  let changed = false;
  try {
    const selected = Number(localStorage.getItem('selectedCourseId'));
    if (selected && !FREE_COURSE_IDS.includes(selected)) {
      localStorage.setItem('selectedCourseId', '1');
      window.dispatchEvent(new CustomEvent('courseSelected', { detail: 1 }));
      changed = true;
    }

    const raw = localStorage.getItem('enrolledCourses');
    if (raw) {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) {
        const ids = parsed.map(Number);
        const kept = ids.filter((id) => FREE_COURSE_IDS.includes(id));
        if (kept.length !== ids.length) {
          localStorage.setItem('enrolledCourses', JSON.stringify(kept.length ? kept : [1]));
          window.dispatchEvent(new CustomEvent('coursesUpdated', { detail: kept.length ? kept : [1] }));
          changed = true;
        }
      }
    }
  } catch (_) {
    // JSON corupt / storage indisponibil
  }
  return changed;
};
